import { Image } from '../../state';
import { ImageActionType } from './image-action-type';
import { RedirectingAction } from '../interfaces';

export interface UploadImageSuccessAction extends RedirectingAction {
  imageKey: string;
  type: ImageActionType.UploadSuccess;
  image: Partial<Image>;
}

export const uploadImageSuccess = (
  imageKey: string,
  image: Partial<Image>,
  options: RedirectingAction = {},
): UploadImageSuccessAction => ({
  ...options,
  image,
  imageKey,
  type: ImageActionType.UploadSuccess,
});
